<a
  class="fdk-footer"
  href="https://www.fastenhealth.com/"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Powered by Fasten Health (opens in a new tab)"
>
  <span>powered by</span>
  <fdk-logo />
</a>
